import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { ContatoShow } from '../../components'
import * as contatoComercializadoraActionCreators from '../../redux/modules/contatoComercializadora'
import * as flashMessageActionCreators from '../../redux/modules/flashMessage'

class ContatoComercializadoraShowContainer extends Component {

  static propTypes = {
    id: PropTypes.string.isRequired,
    comercializadora: PropTypes.object.isRequired,
    fetchContatoComercializadora: PropTypes.func.isRequired,
    destroyContatoComercializadora: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,

    showSuccessfulFlashMessage: PropTypes.func,
    showErrorFlashMessage: PropTypes.func,
    hideFlashMessage: PropTypes.func,
    error: PropTypes.array,
  }

  state = {
    contatoComercializadora: null
  }

  async componentDidMount () {
    if (this.props.id) {
      const contatoComercializadora = await this.props.fetchContatoComercializadora(this.props.id)
      this.setState({ contatoComercializadora })
    }
  }

  handleEditResource = (comercializadoraId, id) => {
    this.props.history.push(`/comercializadoras/${comercializadoraId}/contatos/${id}/edit`)
  }

  handleDeleteResource = async (comercializadoraId, id) => {
    if (await this.props.destroyContatoComercializadora(id)) {
      this.props.showSuccessfulFlashMessage('', 'destroy')
      this.props.history.push(`/comercializadoras/${comercializadoraId}/contatos`)
    } else {
      this.props.showErrorFlashMessage('', 'destroy', this.props.error)
    }
  }

  render () {
    return (
      <ContatoShow noTitle
        comercializadora={this.props.comercializadora}
        onEditResource={() => this.handleEditResource(this.props.comercializadora.id, this.state.contatoComercializadora.id)}
        onDeleteResource={() => this.handleDeleteResource(this.props.comercializadora.id, this.state.contatoComercializadora.id)}
        contato={this.state.contatoComercializadora} />
    )
  }
}

function mapStateToProps ({contatoComercializadora}, {match}) {
  const { id } = match.params
  if (id) {
    return {
      id,
      contatoComercializadora: contatoComercializadora.get('id'),
    }
  }
  return {}
}

function mapDispatchToProps (dispatch) {
  return bindActionCreators({
    ...contatoComercializadoraActionCreators,
    ...flashMessageActionCreators
  }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ContatoComercializadoraShowContainer))
